
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      score: [0, 0],
      direction: [`increase`, `increase`],
      max: 9,
      min: 0,
      shareUrl: ``,
      disabled: false,
    };
  },
  computed: {
    homeTeam () {
      return this.getTeam(this.fixture, `Home`);
    },
    awayTeam () {
      return this.getTeam(this.fixture, `Away`);
    },
    homeLogo () {
      return this.getClubLogo(this.homeTeam.team);
    },
    awayLogo () {
      return this.getClubLogo(this.awayTeam.team);
    },
    homeScore () {
      return this.score[0];
    },
    awayScore () {
      return this.score[1];
    },
    settings () {
      return this.siteSettings.score_predictor;
    },
    share () {
      const writtenScore = `${this.homeTeam.team.teamNames[0].displayName} ${this.homeScore}-${this.awayScore} ${this.awayTeam.team.teamNames[0].displayName}`;
      const fixtureUrl = window.location.href;
      const shareText = this.settings.social_text.replace(`[SCORE]`, writtenScore).replace(`[URL]`, fixtureUrl);
      return {
        text: shareText,
        url: fixtureUrl,
      };
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.shareUrl = window.location.href;

      if (localStorage.scorePredictions) {
        const prediction = JSON.parse(localStorage.scorePredictions).find(prediction => prediction.id === this.fixture.id);

        if (prediction) {
          this.score = [prediction.home, prediction.away];
          this.disabled = true;
        }
      }
    });
  },
  methods: {
    increaseScore (index) {
      if (this.score[index] < this.max) {
        this.$set(this.score, index, this.score[index] + 1);
        this.$set(this.direction, index, `increase`);
      }
    },
    decreaseScore (index) {
      if (this.score[index] > this.min) {
        this.$set(this.score, index, this.score[index] - 1);
        this.$set(this.direction, index, `decrease`);
      }
    },
    confirmScore () {
      let currentPredictions = [];
      if (localStorage.scorePredictions) {
        currentPredictions = JSON.parse(localStorage.scorePredictions);
      }

      if (currentPredictions.find(prediction => prediction.id === this.fixture.id)) {
        currentPredictions = currentPredictions.filter(prediction => prediction.id !== this.fixture.id);
      }

      currentPredictions.push({
        id: this.fixture.id,
        home: this.homeScore,
        away: this.awayScore,
      });

      localStorage.scorePredictions = JSON.stringify(currentPredictions);

      this.disabled = true;
      this.$emit(`scoreChange`, this.score);
    },
  },
};
